import React, { useState } from "react";

import "bootstrap/dist/css/bootstrap.css";
import "./App.css";

import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
} from "react-router-dom";

import RootLayout from "./pages/RootLayout";
import Index from "./pages/IndexPage";
import Login, { action as loginAction } from "./pages/LoginPage";
import Home, { action as homeAction } from "./pages/HomePage";
import Logout from "./pages/LogoutPage";
import ErrorPage from "./pages/ErrorPage";
import TechopsUserTool, {
  action as techopsUserToolAction,
  loader as techopsUserToolLoader,
} from "./pages/TechopsUserToolPage";
import TechopsOrganizationTool, {
  action as techopsOrganizationToolAction,
  loader as techopsOrganizationToolLoader,
} from "./pages/TechopsOrganizationToolPage";

//localStorage.clear();

const jwtEnv = "prod-";

let jwtinfo = localStorage.getItem(jwtEnv + "ftjwt");

function App() {
  const jwtHandler = (jwt) => {
    localStorage.setItem(jwtEnv + "ftjwt", jwt);
    setTimeout(() => {
      setJwt(() => jwt);
    }, 200);
  };

  const logoutHandler = () => {
    localStorage.clear();
    setJwt(() => null);
  };

  const [jwt, setJwt] = useState(localStorage.getItem(jwtEnv + "ftjwt"));

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path="/"
        element={<RootLayout jwt={jwt} />}
        errorElement={<ErrorPage jwt={jwt} />}
      >
        <Route index element={<Index jwt={jwt} />} />
        <Route
          path="/login"
          element={<Login jwtHandler={jwtHandler} jwt={jwt} />}
          action={loginAction}
        />
        <Route
          path="/logout"
          element={<Logout logoutHandler={logoutHandler} jwt={jwt} />}
        />
        <Route path="/home" element={<Home jwt={jwt} />} action={homeAction} />
        <Route
          path="/techopsTool/user/:userId"
          element={<TechopsUserTool jwtHandler={jwtHandler} jwt={jwt} />}
          action={techopsUserToolAction}
          loader={techopsUserToolLoader}
        />
        <Route
          path="/techopsTool/organization/:orgId"
          element={
            <TechopsOrganizationTool jwtHandler={jwtHandler} jwt={jwt} />
          }
          action={techopsOrganizationToolAction}
          loader={techopsOrganizationToolLoader}
        />
      </Route>
    )
  );
  return <RouterProvider router={router} />;
}

export default App;
